import { render, staticRenderFns } from "./detail_head.vue?vue&type=template&id=cdb8e872&"
import script from "./detail_head.vue?vue&type=script&lang=js&"
export * from "./detail_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdb8e872')) {
      api.createRecord('cdb8e872', component.options)
    } else {
      api.reload('cdb8e872', component.options)
    }
    module.hot.accept("./detail_head.vue?vue&type=template&id=cdb8e872&", function () {
      api.rerender('cdb8e872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/order_detail/components/detail_head.vue"
export default component.exports